import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../redux/app/slice.js";
import { useCallback } from "react";

const useLanguage = () => {
  const language = useSelector((state) => state.app.language);
  const dispatch = useDispatch();

  const handleLanguage = useCallback(
    (language) => {
      dispatch(setLanguage(language));
    },
    [dispatch]
  );

  return [language, (language) => handleLanguage(language)];
};

export default useLanguage;
